(() => {
  if (window.LBCCheckoutCROBound) return;
  window.LBCCheckoutCROBound = true;

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-lbc-discount-form]');
    if (!form) return;

    event.preventDefault();

    const input = form.querySelector('[name="discount"]');
    const error = form.querySelector('[data-lbc-discount-error]');
    const button = form.querySelector('button[type="submit"]');
    const code = input ? input.value.trim() : '';

    if (!code) {
      if (error) error.textContent = 'Please enter your discount code.';
      if (input) input.focus();
      return;
    }

    if (error) error.textContent = '';
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Applying…';
    }

    window.location.assign('/discount/' + encodeURIComponent(code) + '?redirect=/checkout');
  });
})();